const dashboards = process.env.VUE_ENV === 'server' ? {} : {
  Referrals: () => import('@src/views/Dashboards/Referrals'),
  InternalMobility: () => import('@src/views/Dashboards/InternalMobility'),
  Mentorship: () => import('@src/views/mentors/MentorsIndex'),
  ReferralJam: () => import('@src/views/Dashboards/ReferralJam'),
  Campaign: () => import('@src/views/Dashboards/Campaign'),
};

export default {
  name: 'DashboardController',
  functional: true,
  metaInfo: {
    title: 'Dashboard',
  },
  render(el, { props, parent }) {
    if (process.env.VUE_ENV === 'server') {
      return el('div', {}, [ 'Loading...' ]);
    } else {
      const { company } = parent.$root;
      const { handle, preferences, sitePreferences } = company || {};

      const chosen = chooseDashboard(handle, { ...sitePreferences, ...preferences });
      const { [chosen || Object.keys(dashboards).shift()]: component } = dashboards;
      return el(component, { props });
    }
  },
};

export function chooseDashboard(companyHandle, preferences) {
  const {
    isReferralsFeatureEnabled: hasReferrals = false,
    isInternalMobilityEnabled: hasInternalMobility = false,
    isMentorshipFeatureEnabled: hasMentorship = false,
    isReferralJamsEnabled: hasReferralJams = false,
    isCampaignsEnabled: hasCampaigns = false,
  } = { ...preferences };

  const enabled = (list => Object.keys(list).filter(k => list[k] === true))({
    hasReferrals,
    hasInternalMobility,
    hasMentorship,
    hasReferralJams,
  });

  if (only(enabled, 'hasReferralJams')) {
    return 'ReferralJam';
  } else if (only(enabled, 'hasMentorship')) {
    return 'Mentorship';
  } else if (hasInternalMobility) {
    return 'InternalMobility';
  } else if (hasCampaigns) {
    return 'Campaign';
  } else {
    return 'Referrals';
  }
}

const only = (enabled, key) => enabled.length === 1 && enabled.includes(key);



// WEBPACK FOOTER //
// ./src/views/Dashboards/Controller.js